export default __webpack_public_path__ + "static/media/notifications.e0bbf6c1.svg";